import { render } from "./AddIcon.vue?vue&type=template&id=6d7ecd4b&bindings={}"
import script from "./AddIcon.vue?vue&type=script&lang=ts"
export * from "./AddIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script